// src/components/InstructionsPage.js

import React from "react";

export default function InstructionsPage() {
  return (
    <div className="w-full min-h-[100dvh] flex flex-col items-stretch p-4 md:p-8">
      <div className="max-w-lg w-full mx-auto flex flex-col gap-6">
        {/* Header ---------------------------------------------------- */}
        <div className="flex flex-col items-center gap-4">
          <img
            src="/pdx_logo.png"
            className="h-24 md:h-32 w-auto asset"
            alt="pDx logo"
          />
          <h1 className="supertitle-text text-primary text-center">
            Whaddon Medical Participant Advice
          </h1>
        </div>

        {/* Study Overview ------------------------------------------- */}
        <section className=" space-y-4">
          <p className="typography">
            Thank you sincerely for taking part in this study, your contribution
            is invaluable.
          </p>

          <p className="typography">
            As part of the research, we kindly ask you to complete a set of
            recordings once a week for the next 12 months. This will include:
          </p>

          <ul className="list-disc list-inside space-y-1 typography">
            <li>
              3 breathing manoeuvres (as demonstrated during your initial clinic
              visit)
            </li>
            <li>1 COPD and Asthma Test questionnaire (CAAT)</li>
          </ul>

          <p className="typography">
            If you notice that your respiratory symptoms are worsening, or if
            you feel generally unwell, we ask that you complete 2–3 additional
            sets of recordings per week during that time.
          </p>
        </section>

        {/* Opening the Website -------------------------------------- */}
        <section className=" space-y-4">
          <h2 className="subtitle-text">Opening the Website</h2>

          <p className="typography">
            Scan the QR code below using your phone&apos;s camera or visit the
            link below.
          </p>
          <div className="w-full flex flex-col items-center justify-center gap-2">
            <img
              src={"/assets/wha-med-qr.png"}
              alt={"https://wha-med.pdx.electronrx.com/auth/login"}
              loading="lazy"
              decoding="async"
              referrerPolicy="no-referrer"
              className="max-w-52  object-cover"
            />
            <p className="typography">
              <a
                href="https://wha-med.pdx.electronrx.com/auth/login"
                className="link text-primary break-all"
                target="_blank"
                rel="noreferrer"
              >
                https://wha-med.pdx.electronrx.com/auth/login
              </a>
            </p>
          </div>
          <p className="typography">
            You will be able to access the website quickly if you leave the tab
            open on your internet browser.
          </p>

          <p className="typography">
            Enter your ID and password to login, your ID should have been
            provided to you on the print out during your visit.
          </p>
        </section>

        {/* Recording Advice ----------------------------------------- */}
        <section className=" space-y-4">
          <h2 className="subtitle-text">Recording Advice</h2>

          {/* <p className="typography font-semibold">Example Video</p> */}

          {/* Positioning */}
          <div className="sub-container">
            <h3 className="title-text">Positioning</h3>
            <p className="typography">
              Place your phone at chest height, ~1-2 metres away. Make sure your
              full upper body (shoulders to waist) is clearly visible and
              centred. Keep your face out of the frame. See reference image
              below.
            </p>
            <img
              src={"/assets/guide_images.png"}
              alt={
                "Example framing: shoulders to waist visible, phone 1-2 m away"
              }
              loading="lazy"
              decoding="async"
              referrerPolicy="no-referrer"
              className="w-full rounded-xl border border-border/50 object-cover"
            />
          </div>

          {/* Clothing */}
          <div className="sub-container">
            <h3 className="title-text">Clothing</h3>
            <p className="typography">
              Wear a patterned, tighter fitting top (avoid loose
              jackets/scarves). If your top is loose or very plain we recommend
              firmly placing 1-2 hands on your chest/abdomen for the recording.
            </p>
          </div>

          {/* During the Recording */}
          <div className="sub-container space-y-3">
            <h3 className="title-text">During the Recording</h3>
            <p className="typography">
              Sit upright with your back firmly against the back of your chair,
              stay as still as you can, and breathe normally before and after
              completing the forced exhale.
            </p>

            <p className="typography">
              There are 3 parts to each spirometry recording
            </p>

            <ol className="list-decimal list-inside space-y-2 typography">
              <li>
                <span className="font-semibold">Initial calibration:</span>
                <ol className="list-[lower-alpha] list-inside ml-4 space-y-1">
                  <li>
                    Either count to 20 or wait until the timer gets to 30
                    seconds and carry out a forced spirometry manoeuvre.
                  </li>
                </ol>
              </li>

              <li>
                <span className="font-semibold">Forced spirometry:</span>
                <ol className="list-[lower-alpha] list-inside ml-4 space-y-1">
                  <li>
                    Only if you have been asked to carry out forced spirometry,
                    if not, just remain as still as possible for the full 60
                    seconds
                  </li>
                  <li>
                    Take a deep breath to fill your lungs and forcefully exhale
                    all the air out of your lungs for 5-10 seconds
                  </li>
                </ol>
              </li>

              <li>
                <span className="font-semibold">Rest period:</span>
                <ol className="list-[lower-alpha] list-inside ml-4 space-y-1">
                  <li>
                    For the remainder of the assessment, remain as still and
                    silent as possible.
                  </li>
                  <li>
                    Where possible, please try to keep any movements to a
                    minimum, as this will be detected by the technology.
                  </li>
                </ol>
              </li>
            </ol>
          </div>

          {/* Lighting */}
          <div className="sub-container">
            <h3 className="title-text">Lighting</h3>
            <p className="typography">
              Use steady, even lighting (avoid backlight from bright windows).
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
